export const messages = {
  en: {
    assetInventoryInStock: {
      title: 'Inventory Information',
      print: 'Print',
      back: 'Back',
      inventoryName: 'Inventory Name',
      inventoryPerson: 'Inventory Person',
      warehouse: 'Warehouse',
      inventoryDate: 'Inventory Date',
      remark: 'Remark',
      status: 'Status',
      inventoryItems: 'Inventory Items',
      warehouseName: 'Warehouse Name',
      itemType: 'Item Type',
      itemName: 'Item Name',
      specification: 'Specification',
      itemCode: 'Item Code',
      isFixedItem: 'Is Fixed Item',
      batchPrice: 'Batch Price',
      originalStock: 'Original Stock',
      inventoryQuantity: 'Inventory Quantity',
      auditInfo: 'Audit Information',
      auditor: 'Auditor',
      contactNumber: 'Contact Number',
      auditTime: 'Audit Time',
      auditOpinion: 'Audit Opinion'
    }
  },
  zh: {
    assetInventoryInStock: {
      title: '盘点信息',
      print: '打印',
      back: '返回',
      inventoryName: '盘点名称',
      inventoryPerson: '盘点人',
      warehouse: '选择仓库',
      inventoryDate: '盘点日期',
      remark: '盘点说明',
      status: '审核状态',
      inventoryItems: '盘点商品',
      warehouseName: '仓库名称',
      itemType: '物品类型',
      itemName: '物品名称',
      specification: '物品规格',
      itemCode: '物品编码',
      isFixedItem: '是否是固定物品',
      batchPrice: '批次价格',
      originalStock: '原有库存',
      inventoryQuantity: '盘点后数量',
      auditInfo: '审核信息',
      auditor: '审核人',
      contactNumber: '联系电话',
      auditTime: '审核时间',
      auditOpinion: '审核意见'
    }
  }
}